import React from "react";
import PropTypes from "prop-types";
import { twMerge } from "tailwind-merge";

const LoginButton = ({
  text,
  onClick,
  className,
  type = "button",
  disabled = false,
}) => {
  return (
    <button
      type={type}
      className={twMerge(`w-full font-inter font-semibold text-[18px] leading-[21.6px] bg-blue-shades text-white py-3 rounded-lg hover:bg-[#060073] transition duration-200`, className)}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </button>
  );
};

LoginButton.propTypes = {
  text: PropTypes.string.isRequired, // Button text
  onClick: PropTypes.func, // Function
  className: PropTypes.string, // customize styles
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  disabled: PropTypes.bool,
};

export default LoginButton;
